const mutations = {
    AUTH_REQUEST: state => {
        state.status = "loading";
    },
    AUTH_PWD_EMAIL: state => {
        state.status = "success";
    },
    AUTH_USERNAME_EMAIL: state => {
        state.status = "success";
    },
    AUTH_SUCCESS: (state, access_token) => {
        state.status = "loading";
        state.access_token = access_token;
        state.hasLoadedOnce = true;
        state.authErrors.clear();
    },
    AUTH_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.status = "error";
        state.hasLoadedOnce = true;
        state.authErrors.record(errors);
    },
    AUTH_LOGOUT: state => {
        state.status = "logout";
    },
    CLEAR_ERRORS: state => {
        state.authErrors.clear();
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
